var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"watch-list-item--color",style:({ backgroundColor: '#' + _vm.item.color })}),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.$filters.shortString(_vm.item.name)))])])}
var staticRenderFns = []

export { render, staticRenderFns }